import styled from 'styled-components';

import Color from '../../styles/color';

type Props = {
  height: number;
};

export const Content = styled.p<Props>`
  font-size: 16px;
  line-height: 24px;
  margin-top: 20px;
  color: ${Color.neutral90};
  ${(h) => h.height > 0 && `{height: ${h.height}px}`};

  button {
    font-size: 16px;
    line-height: 24px;
    color: ${Color.primary};
    display: block;
    background: transparent;
    border: 0;
    padding: 0;
    transition: all 300ms ease;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const ContentWarning = styled.div`
  margin-bottom: 20px;
`;
